import { pdf } from '@react-pdf/renderer';
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Swal from 'sweetalert2';
import { actualizarAlertaLoading, cerrarAlerta, mostraAlertaError, mostrarAlertaLoading } from "../../../../componentes/alerts/sweetAlert";
import { cargarPorRangos, textoProgreso } from "../../../../componentes/datos/CargaPorRangos";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from "../../../../componentes/contenedores/Card";
import { IdentificarEstacion } from "../../../../componentes/estacion/Estacion";
import MetodosPagoDinamicos from "../../../../componentes/metodos/MetodosPagos";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizardBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import { CajaVerificar, VentaAnulada, VentaPagoAnulada, VentaListarId } from "../../../../configuracion/apiUrls";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { ImprimirVenta } from "./ImprimirVentas";
import ReporteVentas from "./ReporteVentas";
import { VentaFiltro } from "../../../../configuracion/apiUrls";


const HomeVerVentas = () => {
    const { usuario } = useContextUsuario();
    const { listaClientes } = useContextEmpleado();
    const refEdicion = useRef(null);
    const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
    const [documentoFiltro, setDocumentoFiltro] = useState("FA");
    const [documentoFiltroTemp, setDocumentoFiltroTemp] = useState("FA");
    const [estadoFiltro, setEstadoFiltro] = useState("TODOS");
    const [estadoFiltroTemp, setEstadoFiltroTemp] = useState("TODOS");
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(
        moment().format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
    const clientes = listaClientes || [];
    const [clienteId, setClienteId] = useState("");
    const [modalClienteOpen, setModalClienteOpen] = useState(false);
    const [clienteSearchTerm, setClienteSearchTerm] = useState("");
    const [selectedEvent, setSelectedEvent] = useState({});

    const [ventasFiltradas, setVentasFiltradas] = useState([]);
    // Controlador de la carga por lotes en curso, para poder cancelarla.
    const refCarga = useRef(null);

    useEffect(() => {
        obtenerVentasFiltradas(documentoFiltroTemp, estadoFiltroTemp, usuario.datoPersonales?.id, selectedEvent?.clienteId, fechaInicio, fechaFin);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Al salir de la pantalla se corta la carga en vuelo: no tiene sentido
    // que el servidor siga trabajando para una vista que ya no existe.
    useEffect(() => {
        return () => {
            if (refCarga.current) {
                refCarga.current.abort();
            }
        };
    }, []);

    /**
     * Fusiona el detalle sobre el objeto que ya venia de la lista.
     * Es deliberadamente conservador: si el endpoint de detalle no trae una
     * clave, o la trae vacia, se conserva la de la lista. Asi el panel nunca
     * muestra menos de lo que mostraba antes de este cambio.
     */
    const fusionarDetalle = (anterior, detalle) => {
        const resultado = { ...anterior };
        Object.keys(detalle).forEach((clave) => {
            const valor = detalle[clave];
            if (valor !== undefined && valor !== null) {
                resultado[clave] = valor;
            }
        });
        return resultado;
    };

    /**
     * Pide la venta por id al seleccionarla, en lugar de depender de que la
     * lista haya traido todas las relaciones. Es el paso que permite que el
     * listado deje de cargar ventadetallepedidos, pagoVenta y companhia para
     * cada fila. Si la peticion falla se queda lo de la lista, sin molestar
     * al usuario con un error.
     */
    const refrescarDetalleVenta = async (venta) => {
        if (!venta?.id) return;
        try {
            const { data } = await AxiosPrivado.get(VentaListarId + venta.id, {
                timeout: 20000,
            });
            const detalle = Array.isArray(data) ? data[0] : data;
            if (!detalle || !detalle.id) return;

            // Puede haber cambiado la seleccion mientras llegaba la respuesta.
            setVentaSeleccionada((previa) =>
                previa?.id === detalle.id ? fusionarDetalle(previa, detalle) : previa
            );
        } catch (error) {
            console.error("No se pudo refrescar el detalle de la venta:", error);
        }
    };

    const handleSeleccionarVenta = (venta) => {
        // Se pinta de inmediato con lo que ya hay para que el panel no quede
        // vacio, y el detalle se refresca cuando llega.
        setVentaSeleccionada(venta);
        setTimeout(() => {
            if (refEdicion.current) {
                refEdicion.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 100);
        refrescarDetalleVenta(venta);
    };

    const handleImprimirVenta = async (venta) => {
        const { id } = venta;
        try {
            const response = await AxiosPrivado.get(VentaListarId + id);
            const venta = response.data;
            //ReporteVentas(venta);
            ImprimirVenta(venta);
        } catch (error) {
            ErroresPeticion(error);
        }
    };

    const Total = ventaSeleccionada?.totalVenta || 0;

    const handleImprimirReporteVentas = async (venta) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        if (venta) {
            const { id } = venta;
            try {
                const response = await AxiosPrivado.get(VentaListarId + id);
                const venta2 = response.data;
                /*const blob = await pdf(<ReporteVentas venta={venta2} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `ReporteVenta_${venta.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);*/
                const blob = await pdf(<ReporteVentas venta={venta2} />).toBlob();
                const url = URL.createObjectURL(blob);

                // Abrir en nueva pestaña
                window.open(url, "_blank");

                // Opcional: liberar el objeto URL después de un tiempo
                setTimeout(() => URL.revokeObjectURL(url), 10000);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };

    const columnas = useMemo(
        () => [
            {
                title: "ID",
                data: null,
                render: (row) => {
                    const factura = row.facturas?.[0]?.numeroFactura;
                    const recibo = row.recibos?.[0]?.id;
                    const credito = row.creditos?.[0]?.id;

                    return `
                        <div class="fw-semibold">#${row.id}</div>

                        ${factura ? `<span class="badge bg-primary">FA ${factura}</span>` : ""}
                        ${recibo ? `<span class="badge bg-info">RC ${recibo}</span>` : ""}
                        ${credito ? `<span class="badge bg-warning text-dark">CR ${credito}</span>` : ""}
                    `;
                }
            },
            {
                title: "Fecha",
                data: null,
                render: (row) => {
                    const fechaStr =
                        row.facturas?.[0]?.fecha ??
                        row.recibos?.[0]?.fecha ??
                        row.creditos?.[0]?.fecha;

                    if (!fechaStr) {
                        return '<span class="text-muted">—</span>';
                    }

                    const fecha = moment(fechaStr);

                    if (!fecha.isValid()) {
                        return '<span class="text-danger">Fecha inválida</span>';
                    }

                    return `
                        <div>${fecha.format("DD/MM/YYYY")}</div>
                        <small class="text-muted">${fecha.format("HH:mm")}</small>
                    `;
                },
            },
            {
                title: "Cliente",
                data: "Cliente",
                render: (cliente, type, row) => {
                    if (!cliente) {
                        return '<span class="text-muted">Sin cliente</span>';
                    }

                    const empresa = cliente.ClienteEmpresas?.[0];

                    const nombre = empresa?.nombre || cliente.nombreCompleto || "Sin cliente";

                    const rtn =
                        row.facturas?.length > 0
                            ? empresa?.rtn || cliente.rtn
                            : null;

                    return `
                        <div class="fw-semibold">
                            ${nombre}
                        </div>

                        ${rtn
                            ? `<div class="small text-muted">
                                    RTN: ${rtn}
                                </div>`
                            : ""
                        }

                        ${empresa && cliente.nombreCompleto
                            ? `<div class="small text-secondary">
                                    ${cliente.nombreCompleto}
                                </div>`
                            : ""
                        }
                    `;
                },
            },
            {
                title: "Vendedor",
                data: null,
                render: (dataRow) => {
                    const vendedor = dataRow.Empleado; const caja = dataRow.caja;
                    return `
                        <div>
                            <div class="fw-bold text-dark">
                                ${vendedor?.nombreCompleto || "Sin vendedor"}
                            </div>
                            ${caja ? `
                                <div class="small text-muted">
                                    Caja: ${caja.nombre}
                                </div>
                                <div class="small text-muted">
                                    Dispositivo: ${caja.estacione?.dispositivo || "-"}
                                </div>
                            ` : ""}
                        </div>
                    `;
                },
            },
            {
                title: "Tipo Venta",
                data: null,
                render: (row) => {
                    const esCredito = row.creditos?.length > 0;
                    const documento = row.facturas?.length > 0
                        ? "Factura"
                        : row.recibos?.length > 0
                            ? "Recibo"
                            : null;

                    return `
                        <div>
                            ${documento
                            ? `<div">${documento}</div>`
                            : ""
                        }
                            <div>
                                ${esCredito
                            ? '<span class="badge bg-warning text-dark">Crédito</span>'
                            : '<span class="badge bg-success">Contado</span>'
                        }
                            </div>
                            
                        </div>
                    `;
                },
            },
            {
                title: "Estado",
                data: "estado",
                render: (data) => {
                    let badgeClass = "";
                    switch (data) {
                        case "Completada":
                            badgeClass = "bg-success text-white";
                            break;
                        case "Anulada":
                            badgeClass = "bg-info text-white";
                            break;
                        case "Pendiente":
                            badgeClass = "bg-warning text-dark";
                            break;
                        default:
                            badgeClass = "bg-secondary text-white";
                    }
                    return `<span class="badge ${badgeClass}">${data}</span>`;
                },
            },
            {
                title: "Total (L)",
                data: "totalVenta",
                render: (data) => {
                    const valorFormateado = formatoMoneda(data);
                    return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
                }
            },
            {
                title: "Acciones",
                data: null,
                orderable: false,
                className: "dt-center all",
                actions: [
                    {
                        key: "ver",
                        className: "btn btn-outline-primary btn-sm",
                        icon: "fas fa-eye",
                        title: "Ver Detalles",
                        onClick: (rowData) => handleSeleccionarVenta(rowData)
                    },
                    {
                        key: "imprimir",
                        className: "btn btn-outline-info btn-sm",
                        icon: "fas fa-print",
                        title: "Imprimir",
                        onClick: (rowData) => handleImprimirVenta(rowData)
                    },
                    {
                        key: "imprimirReporteVentas",
                        className: "btn btn-outline-success btn-sm my-1",
                        icon: "fas fa-chart-bar",
                        title: "Reporte de Venta",
                        onClick: (rowData) => handleImprimirReporteVentas(rowData)
                    }
                ]
            }
        ],
        []
    );

    const datos = {
        titulo: {
            titulo: "Lista de ventas empleado",
            url: "/app/admin/ventas/nuevo",
            tituloUrl: "Nuevas ventas",
            nombreUrl: "Ver ventas",
        },
    };

    // El filtro por tipo de documento es del lado del cliente: depende de
    // que existan facturas/recibos/creditos asociados, no de un campo plano.
    const filtrarPorDocumento = useCallback((ventas, documento) => {
        if (documento === "TODOS") return ventas;
        return ventas.filter((v) => {
            if (documento === "FA") return v.facturas?.length > 0;
            if (documento === "RE") return v.recibos?.length > 0;
            if (documento === "CR") return v.creditos?.length > 0;
            return false;
        });
    }, []);

    /**
     * Carga el rango en ventanas mensuales secuenciales, pintando la tabla
     * mes a mes. Ver CargaPorRangos.js para el detalle del porque.
     */
    const obtenerVentasFiltradas = async (
        documento,
        estado,
        empleado,
        clienteId,
        finicio,
        ffin
    ) => {
        if (refCarga.current) {
            refCarga.current.abort();
        }
        const control = new AbortController();
        refCarga.current = control;

        const desde = finicio || moment().format("YYYY-MM-DD");
        const hasta = ffin || moment().format("YYYY-MM-DD");

        mostrarAlertaLoading("Obteniendo ventas", "Preparando la consulta.");

        try {
            await cargarPorRangos({
                url: VentaFiltro,
                familia: "ventas",
                filtros: {
                    clienteId: clienteId || "",
                    // empleadoId referencia Empleados.id, no Usuarios.id.
                    empleadoId: empleado || usuario.datoPersonales?.id,
                    estado: estado && estado !== "TODOS" ? estado : "",
                },
                desde,
                hasta,
                signal: control.signal,
                onLote: (acumulado, info) => {
                    setVentasFiltradas(filtrarPorDocumento(acumulado, documento));
                    actualizarAlertaLoading(textoProgreso(info));
                },
            });

            cerrarAlerta();
        } catch (error) {
            if (
                error.name === "CanceledError" ||
                error.code === "ERR_CANCELED" ||
                control.signal.aborted
            ) {
                return;
            }

            console.error(error);
            const esTimeout =
                error.code === "ECONNABORTED" ||
                (error.message || "").toLowerCase().includes("timeout");
            mostraAlertaError(
                esTimeout
                    ? "La consulta tardó demasiado. Reduzca el rango de fechas e intente de nuevo."
                    : "Error al obtener las ventas.",
                "Error"
            );
            setVentasFiltradas([]);
        } finally {
            if (refCarga.current === control) {
                refCarga.current = null;
            }
        }
    };

    const filteredClientes = clientes.filter((cliente) => {
        const searchTerm = clienteSearchTerm.trim().toLowerCase();

        // 1. Búsqueda por Nombre Completo del Cliente
        const nombreClienteMatch = cliente.nombreCompleto
            .toLowerCase()
            .includes(searchTerm);

        // 2. Búsqueda por Nombre de la Empresa del Cliente
        const nombreEmpresaMatch =
            cliente.ClienteEmpresas &&
            cliente.ClienteEmpresas.some((empresa) =>
                empresa.nombre.toLowerCase().includes(searchTerm)
            );

        // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
        return nombreClienteMatch || nombreEmpresaMatch;
    });

    const handleClienteSeleccionado = (cliente) => {
        setSelectedEvent((prev) => ({
            ...prev,
            clienteId: cliente.id,
            clienteNombre: cliente.nombreCompleto,
        }));
        setModalClienteOpen(false);
    };

    const handleFiltrar = () => {
        setDocumentoFiltro(documentoFiltroTemp);
        setEstadoFiltro(estadoFiltroTemp);
        setPanelAbierto(false);
        obtenerVentasFiltradas(documentoFiltroTemp, estadoFiltroTemp, usuario.datoPersonales?.id, selectedEvent?.clienteId, fechaInicio, fechaFin);
    };

    const handleReset = () => {
        setFechaInicio(moment().format("YYYY-MM-DD"));
        setFechaFin(moment().format("YYYY-MM-DD"));
        setClienteId("");
        setSelectedEvent({});

        setDocumentoFiltro("FA");
        setDocumentoFiltroTemp("FA");
        setEstadoFiltro("TODOS");
        setEstadoFiltroTemp("TODOS");
        setPanelAbierto(false);
        obtenerVentasFiltradas("FA", "TODOS", usuario.datoPersonales?.id, null, moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"));
    };

    const ultimoPago = useMemo(() => {
        if (!ventaSeleccionada) return null;
        return ventaSeleccionada.pagoVenta
            ?.filter(pv => pv.pago?.estado !== "Anulada" && parseFloat(pv.pago?.recibido) > 0)
            ?.map(pv => pv.pago)
            ?.sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];
    }, [ventaSeleccionada]);

    const pagoYaAnulado = useMemo(() => {
        const pagos = ventaSeleccionada?.pagoVenta ?? [];

        const penultimoPago =
            pagos.length >= 2
                ? pagos[pagos.length - 2]
                : null;

        return penultimoPago?.pago?.estado === "Anulada";
    }, [ventaSeleccionada]);

    const pagosValidos = useMemo(() => {
        if (!ventaSeleccionada) return [];
        return ventaSeleccionada.pagoVenta
            ?.filter(pv => pv.pago?.estado !== "Anulada")
            ?.map(pv => pv.pago)
            ?.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)) || [];
    }, [ventaSeleccionada]);

    const totalVenta = useMemo(() => {
        return parseFloat(ventaSeleccionada?.totalVenta || 0);
    }, [ventaSeleccionada]);

    const saldoAntesDelUltimoPago = useMemo(() => {
        if (pagosValidos.length > 1) {
            const pagosSinUltimo = pagosValidos.slice(0, -1);
            const acumuladoSinUltimo = pagosSinUltimo.reduce(
                (sum, p) => sum + parseFloat(p.recibido || 0),
                0
            );
            return totalVenta - acumuladoSinUltimo;
        } else if (pagosValidos.length === 1) {
            return totalVenta;
        }
        return totalVenta;
    }, [pagosValidos, totalVenta]);

   
    const [paginaCliente, setPaginaCliente] = useState(1);
    const clientesPorPagina = 5;
    const indexUltimoCliente = paginaCliente * clientesPorPagina;
    const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
    const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
    const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);

    const obtenerLineasDePagoDetalladas = (pagoVentaItem, indice) => {
        const lineas = [];

        const datosBase = {
            fecha: pagoVentaItem.pago.fecha,
            documento: pagoVentaItem.pago.documento || `Abono #${indice + 1}`,
            pagoId: pagoVentaItem.pago.id,
        };

        let detalleEncontrado = false;

        pagoVentaItem.pago.pagoefectivos?.forEach((efectivo, idx) => {
            detalleEncontrado = true;
            const cambio = parseFloat(pagoVentaItem.pago.recibido || 0) - parseFloat(pagoVentaItem.pago.pago || 0);
            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-efectivo-${idx}`,
                metodo: "Efectivo",

                // dinero recibido del cliente
                monto: parseFloat(efectivo.monto || 0),

                // dinero aplicado a la venta
                aplicado: parseFloat(efectivo.monto - cambio || 0),

                // cambio entregado
                cambio: cambio,

                cssClass: "text-success",
            });
        });

        pagoVentaItem.pago.pagotarjeta?.forEach((tarjeta, idx) => {
            detalleEncontrado = true;

            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-tarjeta-${idx}`,
                metodo: "Tarjeta",
                monto: parseFloat(tarjeta.monto || 0),
                aplicado: parseFloat(tarjeta.monto || 0),
                cambio: 0,
                cssClass: "text-info",
            });
        });

        pagoVentaItem.pago.pagotransferencia?.forEach((transferencia, idx) => {
            detalleEncontrado = true;

            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-transferencia-${idx}`,
                metodo: "Transferencia",
                monto: parseFloat(transferencia.monto || 0),
                aplicado: parseFloat(transferencia.monto || 0),
                cambio: 0,
                cssClass: "text-primary",
            });
        });

        const montoPagoPrincipal = parseFloat(
            pagoVentaItem.pago.recibido || 0
        );

        if (!detalleEncontrado && montoPagoPrincipal > 0) {
            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-general`,
                metodo: "Pago General",
                monto: montoPagoPrincipal,
                cssClass: "text-warning",
            });
        }

        return lineas;
    };

    const todasLasLineasDePago =
        ventaSeleccionada?.pagoVenta
            ?.filter(item => item.pago?.estado !== "Anulada")
            .sort(
                (a, b) =>
                    new Date(a.pago.fecha) -
                    new Date(b.pago.fecha)
            )
            .flatMap((item, indice) =>
                obtenerLineasDePagoDetalladas(item, indice)
            ) || [];

    const documentoInfo = (() => {
        if (ventaSeleccionada?.facturas?.length > 0) {
            return {
                tipo: "Factura",
                numero: ventaSeleccionada?.facturas[0].numeroFactura,
                badge: "bg-primary"
            };
        }

        if (ventaSeleccionada?.recibos?.length > 0) {
            return {
                tipo: "Recibo",
                numero: ventaSeleccionada?.recibos[0].id,
                badge: "bg-info"
            };
        }

        return null;
    })();

    const obtenerMetodoPago = (pago) => {
        if (pago.pagoefectivos?.length > 0) return "Efectivo";
        if (pago.pagotarjeta?.length > 0) return "POS";
        if (pago.pagotransferencia?.length > 0) return "Transferencia";
        return "No identificado";
    };

    return (
        <Page datos={datos}>
            <Card>
                <div className="mb-4 d-flex justify-content-end">
                    <div className="position-relative">
                        {/* Botón para Abrir/Cerrar Panel */}
                        <button
                            className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                            onClick={() => setPanelAbierto(!panelAbierto)}
                            style={{
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "0.9rem",
                                minWidth: "140px",
                            }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="fas fa-filter mx-2"></i>
                                Filtros
                            </span>
                            <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                        </button>

                        {/* Panel de Filtros */}
                        {panelAbierto && (
                            <div
                                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                                style={{
                                    minWidth: "240px",
                                    right: 0,
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    padding: "15px",
                                    zIndex: 1050,
                                }}
                            >
                                <div className="mb-3">
                                    <label className="form-label">Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fecha fin</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Cliente</label>
                                    <div className="d-flex align-items-center">
                                        {selectedEvent.clienteNombre ? (
                                            <span className="text-success fw-bold">{selectedEvent.clienteNombre}</span>
                                        ) : (
                                            <span className="text-muted">Ninguno seleccionado</span>
                                        )}
                                    </div>
                                    <ModalBootstrap
                                        titulo="Seleccionar cliente"
                                        nombreBoton="Buscar"
                                        estiloBoton="btn btn-sm btn-outline-primary mt-2"
                                        iconBoton="fa-solid fa-magnifying-glass"
                                        modalIsOpen={modalClienteOpen}
                                        setModalIsOpen={setModalClienteOpen}
                                    >
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar cliente..."
                                                value={clienteSearchTerm}
                                                onChange={(e) => setClienteSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped table-hover shadow-smr">
                                                <thead className="bg-dark text-white">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Empresas</th>
                                                        <th>Nombre completo</th>
                                                        <th>Agregar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientesPagina.length > 0 ? (
                                                        clientesPagina.map((cliente) => (
                                                            <tr key={cliente.id}>
                                                                <td>{cliente.id}</td>
                                                                <td className="align-middle">
                                                                    {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                                                        ? cliente.ClienteEmpresas.map((empresa, index) => (
                                                                            <div key={index} className="mb-1">
                                                                                {empresa.nombre}
                                                                            </div>
                                                                        ))
                                                                        : "N/A"}
                                                                </td>
                                                                <td>{cliente.nombreCompleto}</td>
                                                                <td className="text-center align-middle">
                                                                    <button
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() =>
                                                                            handleClienteSeleccionado(cliente)
                                                                        }
                                                                    >
                                                                        <i className="fa-regular fa-square-check" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted">
                                                                No se encontraron clientes.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="d-flex justify-content-center">
                                                <nav className="mt-2">
                                                    <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                                        {/* Botón "Anterior" */}
                                                        <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente - 1)}
                                                                aria-label="Anterior"
                                                            >
                                                                <i className="fas fa-chevron-left me-1"></i> Anterior
                                                            </button>
                                                        </li>

                                                        {
                                                            (() => {
                                                                const pagesToShow = 5;
                                                                const halfPages = Math.floor(pagesToShow / 2);
                                                                let startPage = Math.max(1, paginaCliente - halfPages);
                                                                let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                                                                if (paginaCliente <= halfPages) {
                                                                    endPage = Math.min(totalPaginasCliente, pagesToShow);
                                                                }
                                                                if (paginaCliente > totalPaginasCliente - halfPages) {
                                                                    startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                                                                }

                                                                const pageButtons = [];
                                                                for (let i = startPage; i <= endPage; i++) {
                                                                    pageButtons.push(
                                                                        <li
                                                                            key={i}
                                                                            className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                                                        >
                                                                            <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                                                                {i}
                                                                            </button>
                                                                        </li>
                                                                    );
                                                                }
                                                                return pageButtons;
                                                            })()
                                                        }

                                                        {/* Botón "Siguiente" */}
                                                        <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente + 1)}
                                                                aria-label="Siguiente"
                                                            >
                                                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </ModalBootstrap>
                                </div>
                                {/* Filtro de Documento */}
                                <div className="form-group mb-3">
                                    <label htmlFor="documentoFiltroSelect" className="form-label fw-bold">Documento</label>
                                    <select
                                        id="documentoFiltroSelect"
                                        className="form-control form-control-sm"
                                        // *** Se vincula al estado TEMPORAL ***
                                        value={documentoFiltroTemp}
                                        onChange={(e) => setDocumentoFiltroTemp(e.target.value)}
                                    >
                                        {/* El primer valor es Facturas (el valor por defecto) */}
                                        <option value="FA">Facturas</option>
                                        <option value="RE">Recibos</option>
                                        <option value="CR">Créditos</option>
                                        <option value="TODOS">Todos</option>
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="estadoFiltroSelect" className="form-label fw-bold">Estado</label>
                                    <select
                                        id="estadoFiltroSelect"
                                        className="form-control form-control-sm"
                                        value={estadoFiltroTemp}
                                        onChange={(e) => setEstadoFiltroTemp(e.target.value)}
                                    >
                                        <option value="TODOS">Todos</option>
                                        <option value="Completada">Completada</option>
                                        <option value="Anulada">Anulada</option>
                                    </select>
                                </div>

                                {/* Botones de Acción */}
                                <div className="d-flex justify-content-end">
                                    {/* *** Aplica el filtro con el valor temporal *** */}
                                    <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                        <i className="fas fa-filter mx-1"></i> Filtrar
                                    </button>
                                    {/* *** Resetea a Facturas *** */}
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                        <i className="fas fa-sync-alt mx-1"></i> Reset
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tablas
                    datos={ventasFiltradas}
                    columnas={columnas}
                    id="tablaVentasFiltradas"
                />
            </Card>
            {ventaSeleccionada && (
                <div ref={refEdicion}>
                    <Card
                        pie={
                            <>
                                {(ventaSeleccionada.ventanuladas && ventaSeleccionada.ventanuladas.length > 0) ? (
                                    <div className="card border-danger shadow-sm mt-3">

                                        <div className="card-header bg-danger text-white">

                                            <div className="d-flex align-items-center">

                                                <i className="fas fa-ban mr-2"></i>

                                                <strong>
                                                    Venta Anulada
                                                </strong>

                                            </div>

                                        </div>

                                        <div className="card-body">

                                            <div className="row">

                                                <div className="col-md-6 mb-3">

                                                    <small className="text-muted d-block">
                                                        Motivo de Anulación
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {
                                                            ventaSeleccionada.ventanuladas[0]
                                                                .descripcion
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-md-6 mb-3">

                                                    <small className="text-muted d-block">
                                                        Responsable
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {
                                                            ventaSeleccionada.ventanuladas[0]
                                                                .Empleado?.nombreCompleto
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-md-6">

                                                    <small className="text-muted d-block">
                                                        Fecha de Anulación
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {moment(
                                                            ventaSeleccionada
                                                                .ventanuladas[0]
                                                                .fechaHora
                                                        ).format(
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="col-md-6">

                                                    <small className="text-muted d-block">
                                                        Estado
                                                    </small>

                                                    <span className="badge badge-danger">
                                                        ANULADA
                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                ) : null}
                            </>
                        }
                    >
                        {ventaSeleccionada.ventadetallepedidos?.length > 0 ? (
                            <div className="row justify-content-center">
                                <div className="container-fluid">
                                    <div className="row justify-content-center">
                                        <div className="col-12">

                                            {/* ENCABEZADO */}
                                            <div className="card border-0 shadow-sm">

                                                <div className="card-header py-4">

                                                    <div className="row mb-4">

                                                        <div className="col-md-8">

                                                            <h2 className="h3 mb-2 text-primary fw-bold">
                                                                Informe de Auditoría de Venta
                                                            </h2>

                                                            <p className="text-secondary mb-2">
                                                                Venta #{ventaSeleccionada.id}
                                                            </p>

                                                            <div>

                                                                {documentoInfo && (
                                                                    <span
                                                                        className={`badge mr-2 ${documentoInfo.badge}`}
                                                                    >
                                                                        {documentoInfo.tipo}: {documentoInfo.numero}
                                                                    </span>
                                                                )}

                                                                {ventaSeleccionada.creditos?.[0] && (
                                                                    <span className="badge bg-warning mr-2">
                                                                        Crédito #{ventaSeleccionada.creditos[0].id}
                                                                    </span>
                                                                )}

                                                            </div>

                                                        </div>

                                                        <div className="col-md-4 text-md-right mt-3 mt-md-0">

                                                            <h4 className="mb-1 ">
                                                                Venta
                                                            </h4>

                                                            <p className="text-secondary mb-2">

                                                                Estado de la Venta

                                                            </p>

                                                            <span
                                                                className={`badge px-3 py-2 ${ventaSeleccionada.estado === "Completada"
                                                                    ? "bg-success"
                                                                    : ventaSeleccionada.estado === "Anulada"
                                                                        ? "bg-danger"
                                                                        : "bg-warning text-dark"
                                                                    }`}
                                                            >
                                                                {ventaSeleccionada.estado}
                                                            </span>

                                                        </div>

                                                    </div>

                                                    <hr className="border-secondary opacity-50 my-4" />

                                                    <div className="row">

                                                        {/* INFORMACIÓN DEL CLIENTE */}

                                                        <div className="col-md-6 text-md-left mt-4 mt-md-0">

                                                            <div className="row">
                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        Cliente
                                                                    </small>


                                                                    <strong>
                                                                        {ventaSeleccionada.Cliente?.ClienteEmpresas?.[0]?.nombre ||
                                                                            ventaSeleccionada.Cliente?.nombreCompleto ||
                                                                            "N/A"}
                                                                    </strong>

                                                                </div>
                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        RTN
                                                                    </small>


                                                                    <strong>
                                                                        {ventaSeleccionada.rtn || "N/A"}
                                                                    </strong>

                                                                </div>
                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        Tipo de Venta
                                                                    </small>


                                                                    <strong>
                                                                        {ventaSeleccionada.tipoVenta || "N/A"}
                                                                    </strong>

                                                                </div>
                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        Vendedor
                                                                    </small>


                                                                    <strong>
                                                                        {ventaSeleccionada.Empleado?.nombreCompleto || "N/A"}
                                                                    </strong>

                                                                </div>
                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        Caja
                                                                    </small>

                                                                    <strong>
                                                                        {ventaSeleccionada.caja?.nombre || "N/A"}
                                                                    </strong>
                                                                </div>

                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        Dispositivo
                                                                    </small>

                                                                    <strong>
                                                                        {ventaSeleccionada.caja?.estacione?.dispositivo || "N/A"}
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* INFORMACIÓN DEL DOCUMENTO */}

                                                        <div className="col-md-6 text-md-right mt-4 mt-md-0">

                                                            <div className="row">

                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        {documentoInfo
                                                                            ? `${documentoInfo.tipo}`
                                                                            : "Documento"}
                                                                    </small>

                                                                    <strong>
                                                                        {documentoInfo
                                                                            ? `#${documentoInfo.numero}`
                                                                            : "N/A"}
                                                                    </strong>
                                                                </div>

                                                                <div className="col-6 mb-2">
                                                                    <small className="text-secondary d-block">
                                                                        Pedido
                                                                    </small>

                                                                    <strong>
                                                                        #
                                                                        {ventaSeleccionada.ventapedidos?.[0]?.pedidoId || "N/A"}
                                                                    </strong>
                                                                </div>

                                                                {ventaSeleccionada.creditos?.[0] && (
                                                                    <>
                                                                        <div className="col-6 mb-2">
                                                                            <small className="text-secondary d-block">
                                                                                Estado Crédito
                                                                            </small>

                                                                            <strong
                                                                                className={
                                                                                    ventaSeleccionada.creditos[0].estado === "Pendiente"
                                                                                        ? "text-warning"
                                                                                        : "text-success"
                                                                                }
                                                                            >
                                                                                {ventaSeleccionada.creditos[0].estado}
                                                                            </strong>
                                                                        </div>

                                                                        <div className="col-6 mb-2">
                                                                            <small className="text-secondary d-block">
                                                                                Días Mora
                                                                            </small>

                                                                            <strong
                                                                                className={
                                                                                    ventaSeleccionada.creditos[0].diasMora > 0
                                                                                        ? "text-danger"
                                                                                        : "text-success"
                                                                                }
                                                                            >
                                                                                {ventaSeleccionada.creditos[0].diasMora}
                                                                            </strong>
                                                                        </div>

                                                                        <div className="col-6 mb-2">
                                                                            <small className="text-secondary d-block">
                                                                                Fecha Registro
                                                                            </small>

                                                                            <strong>
                                                                                {moment(
                                                                                    ventaSeleccionada.createdAt
                                                                                ).format("DD/MM/YYYY")}
                                                                            </strong>
                                                                        </div>

                                                                        <div className="col-6 mb-2">
                                                                            <small className="text-secondary d-block">
                                                                                Vencimiento
                                                                            </small>

                                                                            <strong>
                                                                                {moment(
                                                                                    ventaSeleccionada.creditos[0].fechaVencimiento
                                                                                ).format("DD/MM/YYYY")}
                                                                            </strong>
                                                                        </div>
                                                                    </>
                                                                )}

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="card-body">

                                                    {(() => {

                                                        const totalVenta = ventaSeleccionada.ventadetallepedidos.reduce(
                                                            (sum, item) =>
                                                                sum +
                                                                item.cantidad * parseFloat(item.precio || 0),
                                                            0
                                                        );

                                                        const totalPagado =
                                                            ventaSeleccionada.pagoVenta
                                                                ?.filter(p => p.pago.estado !== "Anulada")
                                                                .reduce(
                                                                    (sum, p) =>
                                                                        sum +
                                                                        parseFloat(
                                                                            p.pago.pago || 0
                                                                        ),
                                                                    0
                                                                ) || 0;

                                                        const saldoPendiente = Math.max(
                                                            totalVenta - totalPagado,
                                                            0
                                                        );

                                                        return (
                                                            <>
                                                                {/* KPI */}

                                                                {/* PRODUCTOS */}
                                                                <div className="card shadow-sm mb-4">

                                                                    <div className="card-header">
                                                                        <h5 className="mb-0 font-weight-bold">
                                                                            Detalle de Productos Vendidos
                                                                        </h5>
                                                                    </div>

                                                                    <div className="card-body p-0">

                                                                        <div className="table-responsive">

                                                                            <table className="table align-middle mb-0">

                                                                                <thead>

                                                                                    <tr>

                                                                                        <th
                                                                                            className="border-top-0"
                                                                                            style={{ width: "60px" }}
                                                                                        >
                                                                                            #
                                                                                        </th>

                                                                                        <th className="border-top-0">
                                                                                            Descripción
                                                                                        </th>

                                                                                        <th
                                                                                            className="border-top-0 text-right"
                                                                                            style={{ width: "120px" }}
                                                                                        >
                                                                                            Cantidad
                                                                                        </th>

                                                                                        <th
                                                                                            className="border-top-0 text-right"
                                                                                            style={{ width: "150px" }}
                                                                                        >
                                                                                            Precio Unitario
                                                                                        </th>

                                                                                        <th
                                                                                            className="border-top-0 text-right"
                                                                                            style={{ width: "150px" }}
                                                                                        >
                                                                                            Descuento
                                                                                        </th>

                                                                                        <th
                                                                                            className="border-top-0 text-right"
                                                                                            style={{ width: "180px" }}
                                                                                        >
                                                                                            Subtotal
                                                                                        </th>

                                                                                    </tr>

                                                                                </thead>

                                                                                <tbody>

                                                                                    {ventaSeleccionada.ventadetallepedidos.map(
                                                                                        (detalle, index) => {

                                                                                            const subtotal =
                                                                                                detalle.cantidad *
                                                                                                parseFloat(
                                                                                                    detalle.precio || 0
                                                                                                );

                                                                                            return (
                                                                                                <tr key={index}>

                                                                                                    <td>
                                                                                                        {index + 1}
                                                                                                    </td>

                                                                                                    <td>

                                                                                                        <div className="mb-2">

                                                                                                            <span className="badge badge-secondary mr-1">
                                                                                                                ID {detalle.producto?.id}
                                                                                                            </span>

                                                                                                            <span className="badge badge-dark">
                                                                                                                {detalle.producto?.codigo}
                                                                                                            </span>

                                                                                                        </div>

                                                                                                        <p className="mb-0 font-weight-bold">
                                                                                                            {detalle.producto?.nombre}
                                                                                                        </p>

                                                                                                        {detalle.tipoImpuesto && (
                                                                                                            <small className="text-muted">
                                                                                                                Impuesto: {detalle.tipoImpuesto}
                                                                                                            </small>
                                                                                                        )}

                                                                                                    </td>

                                                                                                    <td className="text-right">
                                                                                                        {detalle.cantidad}
                                                                                                    </td>

                                                                                                    <td className="text-right">
                                                                                                        {formatoMoneda(
                                                                                                            detalle.precio
                                                                                                        )}
                                                                                                    </td>

                                                                                                    <td className="text-right text-muted">
                                                                                                        {formatoMoneda(
                                                                                                            detalle.descuento
                                                                                                        )}
                                                                                                    </td>

                                                                                                    <td className="text-right font-weight-bold">
                                                                                                        {formatoMoneda(
                                                                                                            subtotal
                                                                                                        )}
                                                                                                    </td>

                                                                                                </tr>
                                                                                            );
                                                                                        }
                                                                                    )}

                                                                                </tbody>

                                                                                <tfoot>

                                                                                    <tr>

                                                                                        <td
                                                                                            colSpan="5"
                                                                                            className="text-right font-weight-bold border-top"
                                                                                        >
                                                                                            Subtotal
                                                                                        </td>

                                                                                        <td className="text-right border-top">
                                                                                            {formatoMoneda(
                                                                                                ventaSeleccionada.subtotal
                                                                                            )}
                                                                                        </td>

                                                                                    </tr>

                                                                                    <tr>

                                                                                        <td
                                                                                            colSpan="5"
                                                                                            className="text-right font-weight-bold"
                                                                                        >
                                                                                            ISV 15%
                                                                                        </td>

                                                                                        <td className="text-right">
                                                                                            {formatoMoneda(
                                                                                                ventaSeleccionada.impuesto15
                                                                                            )}
                                                                                        </td>

                                                                                    </tr>

                                                                                    {Number(
                                                                                        ventaSeleccionada.impuesto18 || 0
                                                                                    ) > 0 && (

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="5"
                                                                                                    className="text-right font-weight-bold"
                                                                                                >
                                                                                                    ISV 18%
                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {formatoMoneda(
                                                                                                        ventaSeleccionada.impuesto18
                                                                                                    )}
                                                                                                </td>

                                                                                            </tr>

                                                                                        )}

                                                                                    {Number(
                                                                                        ventaSeleccionada.exento || 0
                                                                                    ) > 0 && (

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="5"
                                                                                                    className="text-right font-weight-bold"
                                                                                                >
                                                                                                    Exento
                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {formatoMoneda(
                                                                                                        ventaSeleccionada.exento
                                                                                                    )}
                                                                                                </td>

                                                                                            </tr>

                                                                                        )}

                                                                                    {Number(
                                                                                        ventaSeleccionada.exonerado || 0
                                                                                    ) > 0 && (

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="5"
                                                                                                    className="text-right font-weight-bold"
                                                                                                >
                                                                                                    Exonerado
                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {formatoMoneda(
                                                                                                        ventaSeleccionada.exonerado
                                                                                                    )}
                                                                                                </td>

                                                                                            </tr>

                                                                                        )}

                                                                                    <tr>

                                                                                        <td
                                                                                            colSpan="5"
                                                                                            className="text-right font-weight-bold h6 border-top"
                                                                                        >
                                                                                            TOTAL FACTURADO
                                                                                        </td>

                                                                                        <td className="text-right font-weight-bold h6 border-top text-primary">
                                                                                            {formatoMoneda(
                                                                                                ventaSeleccionada.totalVenta
                                                                                            )}
                                                                                        </td>

                                                                                    </tr>

                                                                                </tfoot>

                                                                            </table>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div className="row">

                                                                    {/* CONCILIACION */}
                                                                    <div className="col-lg-4 mb-4">

                                                                        <div className="card shadow-sm border-primary">

                                                                            <div className="card-header bg-primary text-white">
                                                                                Conciliación Financiera
                                                                            </div>

                                                                            <div className="card-body">

                                                                                <div className="d-flex justify-content-between mb-3">
                                                                                    <span>
                                                                                        Total Facturado
                                                                                    </span>

                                                                                    <strong>
                                                                                        {formatoMoneda(
                                                                                            totalVenta
                                                                                        )}
                                                                                    </strong>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between mb-3">
                                                                                    <span>
                                                                                        Total Pagado
                                                                                    </span>

                                                                                    <strong className="text-success">
                                                                                        {formatoMoneda(
                                                                                            totalPagado
                                                                                        )}
                                                                                    </strong>
                                                                                </div>

                                                                                <hr />

                                                                                <div className="d-flex justify-content-between">

                                                                                    <span className="fw-bold">
                                                                                        Saldo Pendiente
                                                                                    </span>

                                                                                    <span
                                                                                        className={`fw-bold fs-4 ${saldoPendiente > 0
                                                                                            ? "text-danger"
                                                                                            : "text-success"
                                                                                            }`}
                                                                                    >
                                                                                        {formatoMoneda(
                                                                                            saldoPendiente
                                                                                        )}
                                                                                    </span>

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                        {/* DATOS AUDITORIA */}

                                                                        <div className="card shadow-sm mt-3">

                                                                            <div className="card-header bg-info text-white">
                                                                                Información de Auditoría
                                                                            </div>

                                                                            <div className="card-body">

                                                                                <p>
                                                                                    <strong>Productos:</strong>{" "}
                                                                                    {
                                                                                        ventaSeleccionada
                                                                                            .ventadetallepedidos
                                                                                            .length
                                                                                    }
                                                                                </p>

                                                                                <p className="mb-0">
                                                                                    <strong>
                                                                                        Registros de pago:
                                                                                    </strong>{" "}
                                                                                    {
                                                                                        ventaSeleccionada
                                                                                            .pagoVenta
                                                                                            ?.length
                                                                                    }
                                                                                </p>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* PAGOS */}
                                                                    <div className="col-lg-8">

                                                                        <div className="card shadow-sm">

                                                                            <div className="card-header">
                                                                                <h5 className="mb-0 font-weight-bold">
                                                                                    Libro Auxiliar de Pagos
                                                                                </h5>
                                                                            </div>

                                                                            <div className="card-body p-0">

                                                                                <div className="table-responsive">

                                                                                    <table className="table align-middle mb-0">

                                                                                        <thead>

                                                                                            <tr>

                                                                                                <th
                                                                                                    className="border-top-0"
                                                                                                    style={{ width: "100px" }}
                                                                                                >
                                                                                                    Pago
                                                                                                </th>

                                                                                                <th
                                                                                                    className="border-top-0"
                                                                                                    style={{ width: "170px" }}
                                                                                                >
                                                                                                    Fecha
                                                                                                </th>

                                                                                                <th className="border-top-0">
                                                                                                    Método
                                                                                                </th>

                                                                                                <th
                                                                                                    className="border-top-0 text-right"
                                                                                                    style={{ width: "140px" }}
                                                                                                >
                                                                                                    Recibido
                                                                                                </th>

                                                                                                <th
                                                                                                    className="border-top-0 text-right"
                                                                                                    style={{ width: "140px" }}
                                                                                                >
                                                                                                    Cambio
                                                                                                </th>

                                                                                                <th
                                                                                                    className="border-top-0 text-right"
                                                                                                    style={{ width: "140px" }}
                                                                                                >
                                                                                                    Aplicado
                                                                                                </th>

                                                                                            </tr>

                                                                                        </thead>

                                                                                        <tbody>

                                                                                            {todasLasLineasDePago.length > 0 ? (

                                                                                                todasLasLineasDePago.map(
                                                                                                    linea => (

                                                                                                        <tr key={linea.key}>

                                                                                                            <td>

                                                                                                                <p className="mb-0 font-weight-bold">
                                                                                                                    #{linea.pagoId}
                                                                                                                </p>

                                                                                                                <small className="text-muted">
                                                                                                                    {linea.documento}
                                                                                                                </small>

                                                                                                            </td>

                                                                                                            <td>

                                                                                                                <div>
                                                                                                                    {moment(
                                                                                                                        linea.fecha
                                                                                                                    ).format(
                                                                                                                        "DD/MM/YYYY"
                                                                                                                    )}
                                                                                                                </div>

                                                                                                                <small className="text-muted">
                                                                                                                    {moment(
                                                                                                                        linea.fecha
                                                                                                                    ).format(
                                                                                                                        "HH:mm"
                                                                                                                    )}
                                                                                                                </small>

                                                                                                            </td>

                                                                                                            <td>

                                                                                                                <span
                                                                                                                    className={`badge ${linea.metodo === "Efectivo"
                                                                                                                        ? "badge-success"
                                                                                                                        : linea.metodo === "Tarjeta"
                                                                                                                            ? "badge-info"
                                                                                                                            : linea.metodo === "Transferencia"
                                                                                                                                ? "badge-primary"
                                                                                                                                : "badge-secondary"
                                                                                                                        }`}
                                                                                                                >
                                                                                                                    {linea.metodo}
                                                                                                                </span>

                                                                                                            </td>

                                                                                                            <td className="text-right font-weight-bold">

                                                                                                                {formatoMoneda(
                                                                                                                    linea.monto
                                                                                                                )}

                                                                                                            </td>

                                                                                                            <td className="text-right text-danger">

                                                                                                                {Number(
                                                                                                                    linea.cambio || 0
                                                                                                                ) > 0
                                                                                                                    ? formatoMoneda(
                                                                                                                        linea.cambio
                                                                                                                    )
                                                                                                                    : "-"}

                                                                                                            </td>

                                                                                                            <td className="text-right font-weight-bold text-success">

                                                                                                                {formatoMoneda(
                                                                                                                    linea.aplicado
                                                                                                                )}

                                                                                                            </td>

                                                                                                        </tr>

                                                                                                    )
                                                                                                )

                                                                                            ) : (

                                                                                                <tr>

                                                                                                    <td
                                                                                                        colSpan="6"
                                                                                                        className="text-center text-muted py-4"
                                                                                                    >
                                                                                                        No existen pagos registrados.
                                                                                                    </td>

                                                                                                </tr>

                                                                                            )}

                                                                                        </tbody>

                                                                                        <tfoot>

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="5"
                                                                                                    className="text-right font-weight-bold border-top"
                                                                                                >
                                                                                                    Total Aplicado
                                                                                                </td>

                                                                                                <td className="text-right font-weight-bold text-success border-top">

                                                                                                    {formatoMoneda(totalPagado)}

                                                                                                </td>

                                                                                            </tr>

                                                                                        </tfoot>

                                                                                    </table>

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                {/* ANULADOS */}

                                                                {ventaSeleccionada.pagoVenta?.filter(
                                                                    p => p.pago.estado === "Anulada"
                                                                ).length > 0 && (

                                                                        <div className="card shadow-sm mt-4 border-danger">

                                                                            <div className="card-header">

                                                                                <div className="d-flex justify-content-between align-items-center">

                                                                                    <div>

                                                                                        <h5 className="mb-0 text-danger font-weight-bold">
                                                                                            Pagos Anulados
                                                                                        </h5>

                                                                                        <small className="text-muted">
                                                                                            Movimientos excluidos de la conciliación financiera y del cálculo del saldo pendiente.
                                                                                        </small>

                                                                                    </div>

                                                                                    <span className="badge badge-danger">
                                                                                        {
                                                                                            ventaSeleccionada.pagoVenta.filter(
                                                                                                p => p.pago.estado === "Anulada"
                                                                                            ).length
                                                                                        } Anulado(s)
                                                                                    </span>

                                                                                </div>

                                                                            </div>

                                                                            <div className="card-body p-0">

                                                                                <div className="table-responsive">

                                                                                    <table className="table align-middle mb-0">

                                                                                        <thead>

                                                                                            <tr>

                                                                                                <th className="border-top-0">
                                                                                                    Pago
                                                                                                </th>

                                                                                                <th className="border-top-0">
                                                                                                    Fecha
                                                                                                </th>

                                                                                                <th className="border-top-0">
                                                                                                    Motivo
                                                                                                </th>

                                                                                                <th className="border-top-0">
                                                                                                    Método
                                                                                                </th>

                                                                                                <th
                                                                                                    className="border-top-0 text-right"
                                                                                                    style={{ width: "180px" }}
                                                                                                >
                                                                                                    Monto
                                                                                                </th>

                                                                                            </tr>

                                                                                        </thead>

                                                                                        <tbody>

                                                                                            {ventaSeleccionada.pagoVenta
                                                                                                .filter(
                                                                                                    p =>
                                                                                                        p.pago.estado ===
                                                                                                        "Anulada"
                                                                                                )
                                                                                                .map(p => (

                                                                                                    <tr key={p.pago.id}>

                                                                                                        <td>

                                                                                                            <p className="mb-0 font-weight-bold">
                                                                                                                #{p.pago.id}
                                                                                                            </p>

                                                                                                            <small className="text-danger">
                                                                                                                Anulado
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            <div>
                                                                                                                {moment(
                                                                                                                    p.pago.fecha
                                                                                                                ).format(
                                                                                                                    "DD/MM/YYYY"
                                                                                                                )}
                                                                                                            </div>

                                                                                                            <small className="text-muted">
                                                                                                                {moment(
                                                                                                                    p.pago.fecha
                                                                                                                ).format(
                                                                                                                    "HH:mm"
                                                                                                                )}
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            <p className="mb-0">
                                                                                                                {p.pago.pagoanulados[0].descripcion || "Sin motivo"}
                                                                                                            </p>
                                                                                                            <small className="text-muted">
                                                                                                                {p.pago.pagoanulados[0].Empleado?.nombreCompleto || "Desconocido"}
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            {p.pago.pagoefectivos?.length > 0 && (
                                                                                                                <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                    <span>
                                                                                                                        <span className="badge badge-success mr-2">
                                                                                                                            Efectivo
                                                                                                                        </span>
                                                                                                                    </span>

                                                                                                                    <strong>
                                                                                                                        {formatoMoneda(
                                                                                                                            p.pago.pagoefectivos.reduce(
                                                                                                                                (s, e) => s + Number(e.monto || 0),
                                                                                                                                0
                                                                                                                            )
                                                                                                                        )}
                                                                                                                    </strong>

                                                                                                                </div>
                                                                                                            )}

                                                                                                            {p.pago.pagotarjeta?.length > 0 && (
                                                                                                                <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                    <span>
                                                                                                                        <span className="badge badge-info mr-2">
                                                                                                                            POS
                                                                                                                        </span>
                                                                                                                    </span>

                                                                                                                    <strong>
                                                                                                                        {formatoMoneda(
                                                                                                                            p.pago.pagotarjeta.reduce(
                                                                                                                                (s, e) => s + Number(e.monto || 0),
                                                                                                                                0
                                                                                                                            )
                                                                                                                        )}
                                                                                                                    </strong>

                                                                                                                </div>
                                                                                                            )}

                                                                                                            {p.pago.pagotransferencia?.length > 0 && (
                                                                                                                <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                    <span>
                                                                                                                        <span className="badge badge-primary mr-2">
                                                                                                                            Transferencia
                                                                                                                        </span>
                                                                                                                    </span>

                                                                                                                    <strong>
                                                                                                                        {formatoMoneda(
                                                                                                                            p.pago.pagotransferencia.reduce(
                                                                                                                                (s, e) => s + Number(e.monto || 0),
                                                                                                                                0
                                                                                                                            )
                                                                                                                        )}
                                                                                                                    </strong>

                                                                                                                </div>
                                                                                                            )}

                                                                                                            {(Number(p.pago.recibido || 0) >
                                                                                                                Number(p.pago.pago || 0)) && (

                                                                                                                    <>
                                                                                                                        <hr className="my-1" />

                                                                                                                        <div className="d-flex justify-content-between align-items-center">

                                                                                                                            <span className="text-danger">
                                                                                                                                <i className="fas fa-undo-alt mr-1"></i>
                                                                                                                                Cambio
                                                                                                                            </span>

                                                                                                                            <strong className="text-danger">
                                                                                                                                {formatoMoneda(
                                                                                                                                    Number(p.pago.recibido || 0) -
                                                                                                                                    Number(p.pago.pago || 0)
                                                                                                                                )}
                                                                                                                            </strong>

                                                                                                                        </div>
                                                                                                                    </>
                                                                                                                )}

                                                                                                        </td>

                                                                                                        <td className="text-right font-weight-bold text-danger">

                                                                                                            {formatoMoneda(
                                                                                                                p.pago.pago
                                                                                                            )}

                                                                                                        </td>

                                                                                                    </tr>

                                                                                                ))}

                                                                                        </tbody>

                                                                                        <tfoot>

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="3"
                                                                                                    className="text-right font-weight-bold border-top"
                                                                                                >
                                                                                                    Total Anulado
                                                                                                </td>

                                                                                                <td className="text-right font-weight-bold text-danger border-top">

                                                                                                    {formatoMoneda(
                                                                                                        ventaSeleccionada.pagoVenta
                                                                                                            .filter(
                                                                                                                p =>
                                                                                                                    p.pago.estado ===
                                                                                                                    "Anulada"
                                                                                                            )
                                                                                                            .reduce(
                                                                                                                (sum, p) =>
                                                                                                                    sum +
                                                                                                                    Number(
                                                                                                                        p.pago.pago ||
                                                                                                                        0
                                                                                                                    ),
                                                                                                                0
                                                                                                            )
                                                                                                    )}

                                                                                                </td>

                                                                                            </tr>

                                                                                        </tfoot>

                                                                                    </table>

                                                                                </div>

                                                                            </div>

                                                                        </div>
                                                                    )}
                                                            </>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="alert alert-info text-center py-4 shadow-sm" role="alert">
                                <h5 className="mb-0">ℹ️ No hay detalles o movimientos de pago registrados para esta **venta**.</h5>
                            </div>
                        )}
                    </Card>
                </div>
            )}
        </Page>
    );
};

export default HomeVerVentas;